import { useMemo, useRef, useState } from 'react'
import { Original } from 'src/common/Common.Type'
import BaseBtn from 'src/component/ActionBtn/BaseBtn'
import ReportsPagesContent from 'src/component/ReportsPagesContent'
import { GetPatientMedicalHistory } from 'src/requests/PatientMedicalHistory'
import MedicalNotesHistoryPopup from './Popup/MedicalNotesHistoryPopup'
import CMedicialNotesPopup from './Popup/CMedicialNotesPopup'
import { GetPatientHospitals, SearchPatient } from 'src/requests/Shared'
import { useGet } from 'src/hooks/useGet'

const MedicalNotes = () => {

  const [rowId, setRowId] = useState<number | null>(null)
  const [hospitalId, setHospitalId] = useState<number | null>(null)



  const { data  :hospitalList } = useGet({ API: GetPatientHospitals, isNotValid: !rowId, depArr: [rowId], params: [rowId], defaultValue: [] })

  const medicalHistoryRef = useRef<any>("")
  const updateModalRef = useRef<any>("")

  const columns = useMemo(() => [
    {
      Header: "paitentName",
      accessor: "patientName"
    },
    {
      Header: "patientNationalId",
      accessor: "patientNationalId"
    },
    {
      Header: "phone",
      accessor: "phone"
    },
    {
      Header: "action",
      Cell: ({ row: { original } }: Original) => (
        <>
          <BaseBtn icon={"solar:eye-bold"} className='update' ApplyAction={() => handleModalView(original?.id)} isDisabled={false} />
          <BaseBtn icon={"material-symbols:edit-sharp"} className='update' ApplyAction={() => handleUpdateModal(original?.id, original?.hospitalId)} isDisabled={false} />
        </>
      )
    }
  ], [])

  const handleModalView = (id: number) => {
    setRowId(id)
    medicalHistoryRef.current.click()
  }

  const handleUpdateModal = (id: number, hospitalId: number) => {


    setRowId(id)
    setHospitalId(hospitalId)
    updateModalRef.current.click()
  }

  return (
    <>
      <MedicalNotesHistoryPopup id={rowId} modalId={medicalHistoryRef} />
      <CMedicialNotesPopup  setHospitalId={setHospitalId} hospitalList={hospitalList} setPatientId={setRowId} paitentId={rowId} hospitalId={hospitalId} modalId={updateModalRef} />
      <ReportsPagesContent needParams columns={columns} tableAPI={SearchPatient} />
    </>
  )
}

export default MedicalNotes